import ILocalCacheService from "core/service/cache/ILocalCacheService";
import IRemoteConditionService from "core/service/remoteCondition/IRemoteConditionService";
import { ExternalCallbackRegistry } from "core/util/IExternalCallback";
import ServiceRegistry from "core/util/ServiceRegistry";
import ActionTypes from "./actionTypes";
import { dictionaryLoadEntries } from "./dictionaryActions";

export function userSetLocale(locale: string) {
	return (dispatch, getState) => {

		let language: string;

		// TODO migrate labels to use full locale string?

		if (locale === 'zh_TW' || locale === 'zh-TW') {
			language = 'tw';
		} else if (locale === 'es_MX' || locale === 'es-MX') {
			language = 'mx';
		} else {
			const separatorIndex = locale.search(/(\_|\-)/);
			language = separatorIndex > -1 ? locale.slice(0, separatorIndex) : locale;
		}

		ServiceRegistry.get(ILocalCacheService).put("language", {language, locale});
		dispatch({ type: ActionTypes.USER_LOCALE_SET, language, locale });

		window['__lang'] = language;
		window['__locale'] = locale;

		dispatch(dictionaryLoadEntries(language));
	};
}

export function userSetTimeZone(timeZone: string) {
	return { type: ActionTypes.USER_TIMEZONE_SET, timeZone };
}

export function userSetCondition(externalId: string, value: boolean) {
	return { type: ActionTypes.USER_CONDITION_SET, externalId, value };
}

export function userSetAllConditions(conditions: Record<string, boolean>) {
	return { type: ActionTypes.USER_ALL_CONDITIONS_SET, conditions };
}


export function loadConditionValues() {
	return (dispatch, getState) => {
		const state = getState();
		if (Object.keys(state.config.conditions).length) {
			ServiceRegistry.get(IRemoteConditionService)
				.evaluateConditions(Object.values(state.config.conditions))
				.then((conditions) => {
					const map = conditions.reduce((acc, c) => {
						const { externalId, value } = c;
						return {...acc, [externalId]: value};
					}, {});

					dispatch(userSetAllConditions(map));
				});
		} else {
			// dispatch empty action to satisfy startup requirement
			dispatch(userSetAllConditions({}));
		}
	};
}



// WEBPACK FOOTER //
// ./src/core/actions/userActions.ts